import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { rel } from '../../../../../utils/rel';
import errorBoundary from '@ifeng/errorBoundary';

class Caption extends React.PureComponent {
    handleRevisit = () => {
        window.location.href = window.location.href.split('#')[0];
    };
    /**
     * 渲染网页布局
     */
    render() {
        const { docData, changeView } = this.props;
        const { newsTime, title, source, sourceUrl } = docData;

        return changeView !== 'isOver' ? (
            <div className={styles.titL}>
                <h1>{title}</h1>
                <p>
                    <span>{newsTime.slice(0, newsTime.length - 3)}</span>
                    {sourceUrl ? (
                        <a href={sourceUrl} target="_blank" rel={rel} className={styles.source}>
                            {source}
                        </a>
                    ) : (
                        <span>{source}</span>
                    )}
                </p>
            </div>
        ) : (
            <div className={styles.overReTit}>
                <a className={styles.picAgain} onClick={this.handleRevisit}>
                    图集浏览结束，重新浏览
                    <span className={styles.againBtn} />
                </a>
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * */
Caption.propTypes = {
    docData: PropTypes.object,
    changeView: PropTypes.string,
};

/**
 * 定义组件默认属性
 * */
Caption.defaultProps = {};

export { Caption };
export default errorBoundary(Caption);
